var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"common-button-component",class:{loading : _vm.loading, disabled: _vm.value.disabled},on:{"click":_vm.clickButton}},[_vm._v(" "+_vm._s(_vm.value.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }